export default "__VITE_ASSET__f0fdd2e5__"